@import (reference) '../../../../constants/spacing.module.less';

.property {
  width: 100%;
  height: 24px;
  min-height: 24px;
  font-size: 14px;
  background-color: var(--white);
  color: var(--grey-800);
  border-radius: 0;
}

.select-dropdown {
  .property;
  padding: @space-0 @space-8;

  option {
    height: 24px;
    border: 1px solid var(--grey-300);
  }
}

.input-property {
  .property;
}

.input-range-property {
  .property;

  &.input-range-property {
    min-height: 24px;
    height: 24px;
    border-radius: 0;
  }

  input {
    width: 100%;
  }
}

.color-property-wrapper {
  align-items: center;
  width: 100%;
  height: 24px;
}

.color-property {
  flex: 1;
  height: 24px;
  min-height: 24px;
  font-size: 14px;
  background-color: var(--white);
  color: var(--grey-800);
  border-radius: 0;
  padding: @space-0;
}

.color-property-button {
  height: 100%;
  width: 100%;
  min-height: fit-content;
  cursor: pointer;
  border: 1px solid var(--grey-800);
  border-radius: 0;
  padding: @space-0;
  background: transparent;
  div {
    height: 100%;
    width: 100%;
    border-radius: 0;
    margin: 0;
  }
}

.color-clear-button {
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  cursor: pointer;
  color: var(--grey-800);
  padding: @space-0;
  border: none;
}
